import { Stack } from "@mui/material";

export const getExtendedTooltip = (
  source: string,
  lastUpdated?: string,
  tooltip?: string
) => {
  return (
    <Stack direction={"column"}>
      <span>{source}</span>
      {tooltip && <span>{tooltip}</span>}
      {lastUpdated && <span>{lastUpdated}</span>}
    </Stack>
  );
};
